import { createClient } from "nominatim-client";

export default createClient({
    useragent: "where2meet",
    referer: "https://w2m.phloose.net",
    email: "mail@phloose.net",
});
